<template lang="pug">
  .component-tabbed-vehicle-costs
    .action-bar
      .title
        h2 Vehicle Notes
      .action
        CreateNoteModal(:entity="note.type", :entityId="$route.params.id", @noteCreated="addNote")

    .container
      base-list(:component="component", :dataLoader="dataLoader", :showPerPageSelect="false", ref="baseList", component-type="entityList")
        //header-columns(slot="before", :columns="headers")


</template>
<script type="text/babel">
  import KeplerBackofficeSdk from "src/lib/kepler/backoffice"
  import moment from 'moment'
  import BaseList from '../../../pages/backoffice/BaseList'
  import HeaderColumns from '../../structure/ui/HeaderColumns'
  import collect from 'collect.js'
  import ModalReveal from '../../structure/foundation/ModalReveal'
  import CreateNote from "../../../pages/backoffice/CreateNote";
  import CreateNoteModal from "../../../pages/backoffice/CreateNoteModal";

  export default {
    name: "TabbedVehicleMptes",
    components: {
      CreateNoteModal,
      CreateNote,
      ModalReveal,
      HeaderColumns,
      BaseList,
    },
    data() {
      return {

        headers: ['', 'Cost type', 'Description', 'Amount & Tax', 'Date'],
        note: {type: 'App\\Models\\Vehicle', id: null, description: null},
        component: require('src/components/backoffice/Note'),
      }
    },
    created() {

    },
    methods: {
      addNote() {
        this.$refs.baseList.loadData(1)
      },
      dataLoader(callback, page = 1, resultsPerPage = 25) {
        KeplerBackofficeSdk.notes.list().all({
          per_page: resultsPerPage,
          page_number: page,
          type: 'App\\Models\\Vehicle',
          id:this.$route.params.id
        }, (data) => {
          callback(data)
        })
      },
    },
    computed: {}
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-tabbed-vehicle-costs
    width: 100%
    padding-bottom: 25px
    .container
      margin: 20px
    .roi
      .inner-content
        padding-top: 0
</style>



// WEBPACK FOOTER //
// VehicleNotes.vue?19644fd9